// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/scalebar/scalebar-control.scss
// module id = 466
// module chunks = 0